import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';

export type HomologationAuthStatus =
  | 'pending_signature'
  | 'approved'
  | 'rejected';

const STATUS_COLORS: Record<HomologationAuthStatus, string> = {
  pending_signature: '#FFE6A1',
  approved: '#CEF0DA',
  rejected: '#F8D7DA',
};

export default function HomologationStatusBadge({
  resolution,
  translationKey,
}: {
  resolution: string;
  translationKey?: string;
}) {
  const { t } = useTranslation(
    translationKey ?? TranslationsKeys.HOMOLOGATION_AUTHORIZATION,
  );

  const mappedStatus: HomologationAuthStatus =
    resolution === 'approved'
      ? 'approved'
      : resolution === 'rejected'
      ? 'rejected'
      : 'pending_signature';

  return (
    <Badge
      pill
      className="fs-16 fw-400 py-2 px-4 text-dark"
      style={{ backgroundColor: STATUS_COLORS[mappedStatus], width: 142 }}
    >
      {t(`status.${mappedStatus}`)}
    </Badge>
  );
}
